import {FC} from 'react';
//mui
import {InputLabelProps, InputLabel as MuiInputLabel} from '@mui/material';

interface ExtendedInputLabelProps extends InputLabelProps {
	// label?: string;
	label?: React.ReactNode;

}

const InputLabel: FC<ExtendedInputLabelProps> = ({label, ...rest}) => {
	return <MuiInputLabel {...rest}>{label}</MuiInputLabel>;
};

export default InputLabel;
